import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setAddOnIsOpen } from 'Client/redux/productdetail/actions';
import AnimatedOverlay from '@westwing/ui-kit/AnimatedOverlay';
import AddOnContent from 'Client/components/ProductDetailPage/Overlays/AddOn/AddOnContent';
import { useScrollLockRef } from 'Client/components/Overlays/ScrollableArea';
import { BellaTestIds } from 'Common/qaIds';
import { useBellaSelector } from 'Client/redux/hooks';

const AddOnOverlay = () => {
    const dispatch = useDispatch();
    const addOnIsOpen = useBellaSelector(state => state.productdetails.addOnIsOpen);
    const contentRef = useScrollLockRef({ reserveScrollBarGap: true }, addOnIsOpen);

    const dismissFunction = useCallback(() => {
        dispatch(setAddOnIsOpen(false));
    }, [dispatch]);

    return (
        <AnimatedOverlay
            isOpen={addOnIsOpen}
            dismissFunction={dismissFunction}
            data-testid={BellaTestIds.pdpAddOnOverlay}
            contentRef={contentRef}
        >
            <AddOnContent isOpen={addOnIsOpen} dismissFunction={dismissFunction} />
        </AnimatedOverlay>
    );
};

export default AddOnOverlay;
